import castArray from 'lodash/castArray'
import first from 'lodash/first'
import trim from 'lodash/trim'
import { useRouter } from 'next/router'
import React, { FC } from 'react'

import SearchResults from '@Domains/Product/Features/SearchResults'
import { useBlockConfig } from '@Globals/CMS/Context'

interface SearchResultsBlockProps {
  id?: string
}

const SearchResultsBlock: FC<SearchResultsBlockProps> = ({ id }) => {
  const { query } = useRouter()
  const config = useBlockConfig()

  return (
    <SearchResults
      id={id}
      optionalFilters={config.algolia?.optionalFilters || []}
      query={trim(first(castArray(query.q)))}
    />
  )
}

export default SearchResultsBlock
